import ScanFailureBanner from './ScanFailureBanner';

export default ScanFailureBanner;
